import { Country } from "../model/PersonalInformationType";
import {
    COUNTRIES_DATA,
    SIFARNIK_GOTOVINSKE_TRANSAKCIJE,
    SIFARNIK_IZVORA_OSTALIH_PRIHODA,
    SIFARNIK_KANAL_KRED_PREK,
    SIFARNIK_KANAL_OPCI_DOK,
    SIFARNIK_KANAL_RAC_KART,
    SIFARNIK_OCEKIVANI_PROMET,
    SIFARNIK_PRILJEVA_SREDSTAVA,
    SIFARNIK_PROSJECAN_IZNOS_OSTALIH_PRIHODA,
    SIFARNIK_PROSJECNA_PRIMANJA,
    SIFARNIK_STATUS_ZAPOSLENJA,
    SIFARNIK_SVRHE_RACUNA,
    SIFARNIK_VRSTA_POSLODAVCA,
    SIFARNIK_VRSTA_ZAPOSLJENJA,
    SIFARNIK_VRSTE_TRANSAKCIJA,
    SIFARNIK_KANALI_DOSTAVE,
    SIFARNIK_UKRAJINA_REGIJA
} from "../common/data/sifarnik";
import { Sifarnik } from "../model/FinancialInformationType";
import { SupportedLanguage } from "../i18n";

const CROATIA_COUNTRY_CODE = "HR";
const USA_COUNTRY_CODE = "US";

export const getCountryById = (id: string | null | undefined, lng: SupportedLanguage): Country => {
    if (id === null || id === undefined) {
        return {} as Country;
    }

    const country = COUNTRIES_DATA(lng).find(value => value.oznaka === id);

    if (!country) {
        throw Error(`Couldn't find any country with id ${id}`);
    }

    return country;
};

export const getCountryNullableById = (id: string | null | undefined, lng: SupportedLanguage): Country | null => {
    if (id === null || id === undefined) {
        return {} as Country;
    }

    const country = COUNTRIES_DATA(lng).find(value => value.oznaka === id);

    if (!country) {
        throw Error(`Couldn't find any country with id ${id}`);
    }

    return country;
};

export const getCountriesById = (ids: string[] | null | undefined, lng: SupportedLanguage): Country[] => {
    if (ids === null || ids === undefined) {
        return [] as Country[];
    }

    let countries: Country[] = [];

    for (let id of ids) {
        let country = COUNTRIES_DATA(lng).find(value => value.oznaka === id);

        if (country) {
            countries.push(country);
        } else {
            throw Error(`Couldn't find any country with id ${id}`);

        }
    }

    return countries;
};

export const getSifarnikStatusZaposlenjaById = (id: string | null | undefined): Sifarnik => {
    if (id === null || id === undefined) {
        return {} as Sifarnik;
    }

    const statusZaposlenja = SIFARNIK_STATUS_ZAPOSLENJA.find(value => value.id === id);

    if (!statusZaposlenja) {
        throw Error(`Couldn't find any status zaposlenja with id ${id}`);
    }

    return statusZaposlenja;
};

export const getSifarnikVrstaZaposlenjaById = (id: string | null | undefined): Sifarnik => {
    if (id === null || id === undefined) {
        return {} as Sifarnik;
    }

    const vrstaZaposlenja = SIFARNIK_VRSTA_ZAPOSLJENJA.find(value => value.id === id);

    if (!vrstaZaposlenja) {
        throw Error(`Couldn't find any vrsta zaposlenja with id ${id}`);
    }

    return vrstaZaposlenja;
};

export const getSifarnikGotovinskeTransakcijeById = (id: string | null | undefined): Sifarnik => {
    if (id === null || id === undefined) {
        return {} as Sifarnik;
    }

    const gotovinskaTransakcija = SIFARNIK_GOTOVINSKE_TRANSAKCIJE.find(value => value.id === id);

    if (!gotovinskaTransakcija) {
        throw Error(`Couldn't find any gotovinska transakcija with id ${id}`);
    }

    return gotovinskaTransakcija;
};

export const getSifarnikVrstaPoslodavcaById = (id: string | null | undefined): Sifarnik => {
    if (id === null || id === undefined) {
        return {} as Sifarnik;
    }

    const vrstaPoslodavca = SIFARNIK_VRSTA_POSLODAVCA.find(value => value.id === id);

    if (!vrstaPoslodavca) {
        throw Error(`Couldn't find any vrsta poslodavca with id ${id}`);
    }

    return vrstaPoslodavca;
};

export const getSifarnikOcekivaniPrometById = (id: string | null | undefined): Sifarnik => {
    if (id === null || id === undefined) {
        return {} as Sifarnik;
    }

    const ocekivaniPromet = SIFARNIK_OCEKIVANI_PROMET.find(value => value.id === id);

    if (!ocekivaniPromet) {
        throw Error(`Couldn't find any ocekivani promet with id ${id}`);
    }

    return ocekivaniPromet;
};

export const getSifarnikProsjecanIznosOstalihPrihodaById = (id: string | null | undefined): Sifarnik => {
    if (id === null || id === undefined) {
        return {} as Sifarnik;
    }

    const iznosOstalihPrihoda = SIFARNIK_PROSJECAN_IZNOS_OSTALIH_PRIHODA.find(value => value.id === id);

    if (!iznosOstalihPrihoda) {
        throw Error(`Couldn't find any prosjecan iznos ostalih prihoda with id ${id}`);
    }

    return iznosOstalihPrihoda;
};

export const getSifarnikProsjecnaPrimanjaById = (id: string | null | undefined): Sifarnik => {
    if (id === null || id === undefined) {
        return {} as Sifarnik;
    }

    const prosjecnaPrimanja = SIFARNIK_PROSJECNA_PRIMANJA.find(value => value.id === id);

    if (!prosjecnaPrimanja) {
        throw Error(`Couldn't find any prosjecna primanja with id ${id}`);
    }

    return prosjecnaPrimanja;
};

export const getSifarnikIzvoraOstalihPrihodaByIds = (ids: string[] | null | undefined): Sifarnik[] => {
    if (ids === null || ids === undefined) {
        return [] as Sifarnik[];
    }

    const izvoriOstalihPrihoda = ids.map(id => SIFARNIK_IZVORA_OSTALIH_PRIHODA.find(sifarnik => sifarnik.id === id));

    if (izvoriOstalihPrihoda.filter(value => value === undefined).length > 0) {
        throw Error(`Couldn't find all izvori ostalih prihoda`);
    }

    return izvoriOstalihPrihoda as Sifarnik[];
};

export const getSifarnikSvrhaRarcunaByIds = (ids: string[] | null | undefined): Sifarnik[] => {
    if (ids === null || ids === undefined) {
        return [] as Sifarnik[];
    }

    const svrheRacuna = ids.map(id => SIFARNIK_SVRHE_RACUNA.find(sifarnik => sifarnik.id === id));

    if (svrheRacuna.filter(value => value === undefined).length > 0) {
        throw Error(`Couldn't find all svrhe racuna`);
    }

    return svrheRacuna as Sifarnik[];
};

export const getSifarnikVrsteTransakcijaByIds = (ids: string[] | null | undefined): Sifarnik[] => {
    if (ids === null || ids === undefined) {
        return [] as Sifarnik[];
    }

    const vrsteTransakcija = ids.map(id => SIFARNIK_VRSTE_TRANSAKCIJA.find(sifarnik => sifarnik.id === id));

    if (vrsteTransakcija.filter(value => value === undefined).length > 0) {
        throw Error(`Couldn't find all vrste transakcija`);
    }

    return vrsteTransakcija as Sifarnik[];
};

export const getSifarnikPriljevaSredstavaByIds = (ids: string[] | null | undefined): Sifarnik[] => {
    if (ids === null || ids === undefined) {
        return [] as Sifarnik[];
    }

    const priljeviSredstava = ids.map(id => SIFARNIK_PRILJEVA_SREDSTAVA.find(sifarnik => sifarnik.id === id));

    if (priljeviSredstava.filter(value => value === undefined).length > 0) {
        throw Error(`Couldn't find all priljeve sredstava`);
    }

    return priljeviSredstava as Sifarnik[];
};

export const getSifarnikKanalRacKartById = (id: string | null | undefined): Sifarnik => {
    if (id === null || id === undefined) {
        return {} as Sifarnik;
    }

    const kanalRacKart = SIFARNIK_KANAL_RAC_KART.find(value => value.id === id);

    if (!kanalRacKart) {
        throw Error(`Couldn't find any kanal rac. kart with id ${id}`);
    }

    return kanalRacKart;
};

export const getSifarnikKanalKredPrekById = (id: string | null | undefined): Sifarnik => {
    if (id === null || id === undefined) {
        return {} as Sifarnik;
    }

    const kanalKredPrek = SIFARNIK_KANAL_KRED_PREK.find(value => value.id === id);

    if (!kanalKredPrek) {
        throw Error(`Couldn't find any kanal kred. prek. with id ${id}`);
    }

    return kanalKredPrek;
};

export const getSifarnikKanalOpciDokById = (id: string | null | undefined): Sifarnik => {
    if (id === null || id === undefined) {
        return {} as Sifarnik;
    }

    const kanalOpciDok = SIFARNIK_KANAL_OPCI_DOK.find(value => value.id === id);

    if (!kanalOpciDok) {
        throw Error(`Couldn't find any kanal opci dok. with id ${id}`);
    }

    return kanalOpciDok;
};

export const getSifarnikKanaliDostaveByIds = (ids: string[] | null | undefined): Sifarnik[] => {
    if (ids === null || ids === undefined) {
        return [] as Sifarnik[];
    }

    const kanaliDostave = ids.map(id => SIFARNIK_KANALI_DOSTAVE.find(sifarnik => sifarnik.id === id));

    if (kanaliDostave.filter(value => value === undefined).length > 0) {
        throw Error(`Couldn't find all kanali dostave`);
    }

    return kanaliDostave as Sifarnik[];
};

// The Ukraine region is stored using the same { oznaka, drzava } shape as a Country
// so it can reuse AutocompleteField and the existing country-field handling.
export const getUkrajinaRegijaOptions = (t: (key: string) => string): Country[] =>
    SIFARNIK_UKRAJINA_REGIJA.map(regija => ({ oznaka: regija.id, drzava: t(regija.vrijednost) }));

export const getUkrajinaRegijaById = (id: string | null | undefined, t: (key: string) => string): Country => {
    if (id === null || id === undefined || id === "") {
        return {} as Country;
    }

    const regija = SIFARNIK_UKRAJINA_REGIJA.find(value => value.id === id);

    if (!regija) {
        return {} as Country;
    }

    return { oznaka: regija.id, drzava: t(regija.vrijednost) };
};

export const getCountryDataWithCroatiaBeingFirst = (lng: SupportedLanguage) => {
    return withCroatiaFirst(COUNTRIES_DATA(lng));
};

export const getCountryDataWithoutExcludedCountries = (excludedCountryCodes: string[], lng: SupportedLanguage) => {
    const allExcludedCountryCodes = new Set([
        USA_COUNTRY_CODE,
        ...excludedCountryCodes,
    ]);

    const filteredCountryData = COUNTRIES_DATA(lng).filter(c => !allExcludedCountryCodes.has(c.oznaka));

    return withCroatiaFirst(filteredCountryData);
};


const withCroatiaFirst = (data: Country[]): Country[] => {
    const croatia = data.find(c => c.oznaka === CROATIA_COUNTRY_CODE);

    if (!croatia) {
        return data;
    }

    return [
        croatia,
        ...data.filter(c => c.oznaka !== CROATIA_COUNTRY_CODE),
    ];
};
